import { coreInitiativesCommentsGetAsyncSlice } from './get';
import { CoreInitiativesCommentsName } from './name';
import { createAddCollectionSyncSlice } from '@sonar-software/xuder';
import { InitiativeComment } from '@types';

export const coreInitiativesCommentsAddSyncSlice = createAddCollectionSyncSlice({
	add: (comment: InitiativeComment) => comment,
	hasRequest: true,
	name: CoreInitiativesCommentsName,
	state: coreInitiativesCommentsGetAsyncSlice.asyncState
});
